import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', conferma: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className="auth-page fade-in">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <h2>Link non valido</h2>
          <p style={{ color: '#6b7280' }}>Il link di reset non è valido o è scaduto.</p>
          <p style={{ marginTop: 24, fontSize: 14 }}>
            <Link to="/forgot-password" style={{ color: '#1a56db' }}>Richiedi un nuovo link</Link>
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.conferma) {
      toast.error('Le password non coincidono');
      return;
    }
    if (form.password.length < 6) {
      toast.error('La password deve essere di almeno 6 caratteri');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, password: form.password });
      setDone(true);
      toast.success('Password aggiornata con successo!');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore durante il reset');
    }
    setLoading(false);
  };

  if (done) {
    return (
      <div className="auth-page fade-in">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
          <h2>Password aggiornata!</h2>
          <p style={{ color: '#6b7280' }}>La tua password è stata reimpostata con successo. Verrai reindirizzato al login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page fade-in">
      <div className="auth-card">
        <h2>Reimposta Password</h2>
        <p className="subtitle">Scegli una nuova password per il tuo account.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nuova Password</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="Minimo 6 caratteri"
              required
              minLength={6}
            />
          </div>
          <div className="form-group">
            <label>Conferma Password</label>
            <input
              type="password"
              value={form.conferma}
              onChange={e => setForm({...form, conferma: e.target.value})}
              placeholder="Ripeti la password"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Aggiornamento...' : 'Aggiorna Password'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6b7280' }}>
          <Link to="/login" style={{ color: '#1a56db' }}>← Torna al login</Link>
        </p>
      </div>
    </div>
  );
}
